export { default } from "./appendOwnerState.mjs";